/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserStatusEnum = 0 | 1 | 2;

export const UserStatusEnum = {
    Pending: 0 as UserStatusEnum,
    Approved: 1 as UserStatusEnum,
    Declined: 2 as UserStatusEnum
};

